import { RoutingUrls } from '@cpak/enums';

export enum PakPageTypeName {
  Quote,
  Prototype,
  Template,
}

export const pakRouteToPageTypeMap: Map<RoutingUrls, PakPageTypeName> = new Map([
  [RoutingUrls.BomTemplates, PakPageTypeName.Template],
  [RoutingUrls.Quotes, PakPageTypeName.Quote],
  [RoutingUrls.Prototypes, PakPageTypeName.Prototype],
]);
